import { format, isValid, parse } from "date-fns";

const safelyFormatDate = (date, formatString, fallback = "") => {
  if (date === null || date === undefined || date === "") {
    return fallback;
  }

  const parsedDate = new Date(date);

  if (!isValid(parsedDate)) {
    console.warn(
      `[DateFormatter] Invalid date received: "${date}". Returning fallback.`,
    );
    return fallback;
  }

  return format(parsedDate, formatString);
};

const formatDateForAPI = (date) => safelyFormatDate(date, "yyyy-MM-dd", null);
const formatDateForColumn = (date) =>
  safelyFormatDate(date, "MMM dd, yyyy", "N/A");

// Typed date with a 2-digit year: "10/10/26" -> Oct 10 2026.
// Returns null when the text isn't MM/dd/yy.
const parseTwoDigitYear = (text) => {
  if (!/^\d{2}\/\d{2}\/\d{2}$/.test(text || "")) return null;
  const date = parse(text, "MM/dd/yy", new Date());
  return isValid(date) ? date : null;
};

export { formatDateForAPI, formatDateForColumn, parseTwoDigitYear };
